import { render, staticRenderFns } from "./AttachmentPreviewDialog.vue?vue&type=template&id=efc4d67e&scoped=true"
import script from "./AttachmentPreviewDialog.vue?vue&type=script&lang=ts"
export * from "./AttachmentPreviewDialog.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentPreviewDialog.vue?vue&type=style&index=0&id=efc4d67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc4d67e",
  null
  
)

export default component.exports